// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__1s8nu","content":"styles_content__3UYYu","checkbox":"styles_checkbox__3rRhB","checkboxLabel":"styles_checkboxLabel__1P3mO"};